export default __webpack_public_path__ + "static/media/6.28cf9b0d.jpg";